import { render, staticRenderFns } from "./agreementText.vue?vue&type=template&id=6bf3c9e9&scoped=true&"
import script from "./agreementText.vue?vue&type=script&lang=js&"
export * from "./agreementText.vue?vue&type=script&lang=js&"
import style0 from "./agreementText.vue?vue&type=style&index=0&id=6bf3c9e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf3c9e9",
  null
  
)

export default component.exports